/**
 * Class to select language
 */
export default class SwitcherLanguage {
  constructor() {
    SwitcherLanguage.openSwitcherLanguage();
    SwitcherLanguage.HrefLangSwitcherLanguage();
  }

  /*
   * Switch language box
   */
  private static HrefLangSwitcherLanguage() {
    const switchOptions = document.querySelectorAll(
      '.c-switcherLanguage__option a, .c-switcherLanguageDesktop__option a'
    );
    Array.from(switchOptions).forEach((element: HTMLLinkElement) => {
      element.classList.add('processed');
      const locale = element.getAttribute('data-locale');
      const hrefLang = document.querySelector(
        `.switch_lang[data-locale="${locale}"]`
      );
      if (typeof hrefLang !== 'undefined' && hrefLang) {
        element.setAttribute('href', hrefLang.getAttribute('href'));
      }
    });
  }

  /*
   * Open language box
   */
  private static openSwitcherLanguage() {
    const selectedClass = 'c-switcherLanguage__flag';
    const selected: HTMLElement = document.querySelector(`.${selectedClass}`);

    if (selected) {
      selected.addEventListener(
        'click',
        (event) => {
          if (event.target instanceof HTMLElement) {
            const currentElement: HTMLElement = event.target;

            // Add slide event
            if (
              currentElement.classList.contains(selectedClass) ||
              currentElement.closest(`.${selectedClass}`)
            ) {
              selected.classList.toggle('is-active');
            }
          }
        },
        { passive: true }
      );
    }
  }
}
